import React from "react";

import { translate as suluTranslate } from "sulu-admin-bundle/utils";

const FooterStaffRow = ({ noOfSelectedPlayer, minStaff, maxStaff }) => {
    const minStaffNumber = minStaff - noOfSelectedPlayer;
    const maxStaffNumber = noOfSelectedPlayer - maxStaff;

    const warningMessage =
        noOfSelectedPlayer < minStaff
            ? suluTranslate("sulu_admin.match.staff_min", {
                  number: minStaffNumber,
              })
            : noOfSelectedPlayer > maxStaff
            ? suluTranslate("sulu_admin.match.staff_max", {
                  number: maxStaffNumber,
              })
            : "";

    const numberColor = {
        color:
            noOfSelectedPlayer < minStaff
                ? "red"
                : noOfSelectedPlayer > maxStaff
                ? "red"
                : "green",
    };

    return (
        <>
            <div
                style={{
                    backgroundColor: "#E5E5E5",
                    fontSize: "16px",
                    padding: "10px 20px",
                    border: "1px solid #DDDDDD",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                Staff gesamt {noOfSelectedPlayer}
                <strong style={numberColor}>
                    ({`${minStaff} - ${maxStaff}`})
                </strong>
                {warningMessage && (
                    <div
                        style={{
                            color: "red",
                            fontSize: "12px",
                        }}
                    >
                        {warningMessage}
                    </div>
                )}
            </div>
        </>
    );
};

export default FooterStaffRow;
